;(function($, undefined) {

    var rnn = window.rnn,
        log = rnn.logging.log,
        modules,
        initStack = [],
        postInitStack = [];



    /////////////////////
    // Register new module
    /////////////////////

    function register(moduleName, module, postInitFunction) {

        if (modules[moduleName]) {
            initStack = _.without(initStack, moduleName);
        }

        modules[moduleName] = module;

        modules[moduleName].moduleName = moduleName;

        if (typeof module.init === "function") {
            initStack.push(moduleName);
        }
    }


    /////////////////////
    // Initialise Modules
    /////////////////////

    function initialiseModules() {

        initStack = initStack.reverse();
        while (initStack.length) {

            var moduleName = initStack.pop();

            log('[modules]', 'initialising ' + moduleName);
            try {
                modules[moduleName].init();
            } catch (err) {
                console.error("[modules] Error initialising " + moduleName, err);
            }
        }
    }

    modules = rnn.modules = {
        register: register,
        init: initialiseModules
    };

})(jQuery);
